var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "app-card", attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "d-flex align-center pb-0" },
        [
          _c("text-field-label", {
            attrs: { label: _vm.$t("connector.website.cloudflare") }
          }),
          _c("v-spacer"),
          !_vm.dialog
            ? _c("title-label", {
                staticClass: "mr-3",
                attrs: { label: _vm.statusText }
              })
            : _vm._e(),
          _vm.dialog
            ? _c(
                "v-btn",
                {
                  staticClass: "text-subtitle-1",
                  attrs: { color: "blue darken-1", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.setDialog(false)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("app.btn.cancel")) + " ")]
              )
            : _c(
                "v-btn",
                {
                  staticClass: "text-subtitle-1",
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.setDialog(true)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.btnTextEdit) + " ")]
              )
        ],
        1
      ),
      _c(
        "v-card-text",
        [
          _c("v-expand-transition", [
            _vm.dialog
              ? _c(
                  "div",
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        attrs: {
                          readonly: _vm.isReadonly,
                          "lazy-validation": ""
                        },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submit()
                          }
                        },
                        model: {
                          value: _vm.valid,
                          callback: function($$v) {
                            _vm.valid = $$v
                          },
                          expression: "valid"
                        }
                      },
                      [
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              {
                                attrs: { cols: "5", md: "3", "offset-md": "1" }
                              },
                              [
                                _c("text-field-label", {
                                  attrs: {
                                    label: _vm.$t(
                                      "connector.website.field.cloudflareAuthEmail.label"
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "7", md: "6" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    rules: _vm.rule.cloudflareAuthEmail,
                                    "error-messages":
                                      _vm.error.cloudflareAuthEmail,
                                    dense: "",
                                    outlined: ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.markAsDirty($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.cloudflareAuthEmail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "cloudflareAuthEmail",
                                        $$v
                                      )
                                    },
                                    expression: "form.cloudflareAuthEmail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "pb-0",
                                attrs: { cols: "5", md: "3", "offset-md": "1" }
                              },
                              [
                                _c("text-field-label", {
                                  attrs: {
                                    label: _vm.$t(
                                      "connector.website.field.cloudflareAuthKey.label"
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "pb-0",
                                attrs: { cols: "7", md: "6" }
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    rules: _vm.rule.cloudflareAuthKey,
                                    "error-messages":
                                      _vm.error.cloudflareAuthKey,
                                    dense: "",
                                    outlined: ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.markAsDirty($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.cloudflareAuthKey,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "cloudflareAuthKey",
                                        $$v
                                      )
                                    },
                                    expression: "form.cloudflareAuthKey"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-3",
                                attrs: {
                                  offset: "5",
                                  "offset-md": "4",
                                  cols: "4"
                                }
                              },
                              [
                                _c("save-change-button", {
                                  staticClass: "mr-1",
                                  attrs: {
                                    state: _vm.state,
                                    disabled: !_vm.isDirty || !_vm.valid
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.submit()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }